<template>
    <!-- Main sidebar -->
    <div class="sidebar sidebar--dark sidebar-main sidebar-fixed sidebar-expand-md  bg-gradient-primary" id="accordionSidebar">
    <div class="sidebar-close-wrap" id="sidebarToggleMob">
        <div type="button" @click="_toggleSidebarMobile" class="sidebar-close">
            <span></span>
            <span></span>
        </div>
        
    </div>
    <div style="text-align: start!important;" class="navbar-brand d-sm-none d-flex align-items-center justify-content-center ">
    <a href="/" class="d-inline-block">
        <h1 class=" font-weight-bolder logo__custom  ">
        {{site_settings.name }}
        </h1>
    </a>
    </div>
    
    <div class="sidebar-wrap" data-title="orders">                
        <div class="sidebar-top">

            <div class="d-block d-md-none d-lg-block">

            <div  class="d-flex align-items-center justify-content-center mt-4 text-center">
                <router-link  :to="{ name: 'PlaceOrder' }"  class="btn-main px-4 btn--custom" type="button" id="of-onbording">Order now</router-link>
            </div>
            </div>
            <ul class="navbar-nav">
                <!-- Sidebar - Brand -->
                <a class="sidebar-brand d-flex align-items-center" href="/orders" >
                </a>   

                <li
                v-for="(item, index) in baseMenuItems"
                :key="index + 'bmi'"
                class="nav-item ">
                    <router-link :to="{ name: item.routeName }" class="nav-link " >            
                        <span class="nav-link-item" id="order-onbording">
                            <i :class="item.icon"></i>
                            <span class="nav-link-name">{{ item.text }} </span>
                        </span>
                    </router-link> 
                </li>
                <li
                v-for="(item, index) in sidebarMenu"
                :key="index + 'om'"
                class="nav-item">
                    <router-link
                    @click="getSidebarMenu"
                    :to="{ name: 'OrderListing', params: { status: item.value } }"
                                
                    class="nav-link  ">
                    <span class="nav-link-item" id="msgs-onbording">
                        <i class="icon-pencil"></i>
                        <span class="nav-link-name">{{ item.name }}</span>
                        
                    </span>
                    <div
                    style="
                      width: 150px;
                      " 
                     class="">
                      <p   
                      style=" 
                      width: 24px;
                      text-align: right;
                      float: right;
                      margin-top: 8px !important;
                      "               
                        class="badge d-flex align-items-center justify-content-center mt-2  badge-pill mr-3 "
                        :class="`bg-${item.color || 'dark'}`"
                        >{{ item.no || 0 }}</p>
                    </div>
                    
                    
                    </router-link>
                    
                </li>
                <li class="nav-item ">
                    <a @click="doLogout" class="nav-link " >            
                        <span class="nav-link-item" id="writers-onbording">
                          <i class="icon-lock"></i>
                            <span class="nav-link-name">Logout</span>
                        </span>
                    </a>
                </li> 

               <!-- <li class="nav-item">
                    <a class="nav-link " href="/profile">            
                        <span class="nav-link-item"><i class="fas fa-fw fa-cog"></i><span class="nav-link-name">Settings</span></span>
                    </a>
                </li>         -->
            </ul>

            <!-- Sidebar Toggler (Sidebar) -->
            <div class="text-center d-none d-md-block d-lg-none collapse-sidebar-wrap">
                <div class="collapse-sidebar-block">
                    <button class="collapse-sidebar border-0" id="sidebarToggle">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M12.2485 11.8759C12.3344 11.9586 12.4418 12 12.5598 12C12.6779 12 12.7853 11.9586 12.8712 11.8759C13.0429 11.7103 13.0429 11.4414 12.8712 11.2759L7.39613 6L12.8712 0.724138C13.0429 0.558621 13.0429 0.289655 12.8712 0.124138C12.6994 -0.0413793 12.4203 -0.0413794 12.2485 0.124138L6.46216 5.7C6.29039 5.86552 6.29039 6.13448 6.46216 6.3L12.2485 11.8759Z" fill="white"></path><path d="M6.24852 11.8759C6.33441 11.9586 6.44176 12 6.55985 12C6.67794 12 6.78529 11.9586 6.87117 11.8759C7.04294 11.7103 7.04294 11.4414 6.87117 11.2759L1.39613 6L6.87118 0.724138C7.04294 0.558621 7.04294 0.289655 6.87118 0.124138C6.69941 -0.0413793 6.42029 -0.0413794 6.24852 0.124138L0.462157 5.7C0.290391 5.86552 0.290391 6.13448 0.462157 6.3L6.24852 11.8759Z" fill="white"></path></svg>
                    </button>
                </div>
            </div>
            <div class="d-block d-sm-block d-md-none">
                <div class="d-flex align-items-center justify-content-center text-center">
                        <a href="/loyalty_program?credits=tab" class="btn-balance">My balance:<span>${{ wallet_balance.balance || 0 }}</span></a>
                </div>
            </div>
            
            
            <div class="align-items-center justify-content-center text-center logout-block">
                <a href="/auth?logout=true" class="btn-logout"><svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M11.2927 10.2423C10.9022 10.6241 10.9022 11.2434 11.2927 11.6253C11.488 11.8163 11.7439 11.9118 11.9999 11.9118C12.2557 11.9118 12.5117 11.8163 12.7069 11.6253L15.7068 8.69157C15.7299 8.66895 15.7518 8.64515 15.7726 8.62044C15.7772 8.61496 15.7812 8.60896 15.7857 8.60336C15.8014 8.58386 15.8168 8.56424 15.831 8.54357C15.8347 8.53816 15.8378 8.53242 15.8413 8.52701C15.8554 8.50556 15.8692 8.48385 15.8815 8.46135C15.8836 8.45744 15.8853 8.45333 15.8874 8.44935C15.9003 8.42497 15.9126 8.40026 15.9234 8.3747C15.9246 8.37209 15.9253 8.36942 15.9264 8.36681C15.9375 8.34002 15.9477 8.31276 15.9564 8.28479C15.9573 8.28179 15.9578 8.27866 15.9588 8.27566C15.967 8.24835 15.9744 8.22064 15.9802 8.19234C15.9818 8.18445 15.9825 8.17637 15.9839 8.16841C15.9881 8.14494 15.9922 8.12147 15.9947 8.09748C15.998 8.06514 15.9998 8.0326 15.9998 7.99987C15.9998 7.96708 15.998 7.93454 15.9947 7.90227C15.9922 7.87808 15.988 7.85441 15.9838 7.83075C15.9824 7.82299 15.9817 7.8151 15.9801 7.8074C15.9743 7.77891 15.9668 7.75107 15.9586 7.72356C15.9577 7.72069 15.9572 7.71782 15.9563 7.71495C15.9476 7.68679 15.9372 7.6594 15.926 7.63234C15.925 7.63 15.9244 7.62745 15.9233 7.62511C15.9124 7.59942 15.9 7.57451 15.887 7.55C15.885 7.54622 15.8834 7.54224 15.8814 7.53852C15.8689 7.51583 15.8551 7.49406 15.841 7.47248C15.8374 7.46713 15.8345 7.46152 15.8309 7.45624C15.8167 7.43557 15.8012 7.41582 15.7855 7.39632C15.781 7.39072 15.7771 7.38478 15.7725 7.37931C15.7517 7.3546 15.7298 7.3308 15.7066 7.30817L12.7068 4.37434C12.3163 3.99241 11.6831 3.99241 11.2926 4.37434C10.9021 4.75628 10.9021 5.37548 11.2926 5.75741L12.5855 7.02188H0.999994C0.447731 7.02188 0 7.45976 0 7.99987C0 8.53998 0.447731 8.97786 0.999994 8.97786H12.5856L11.2927 10.2423Z" fill="white"></path><path d="M13.8191 0C11.0894 0 8.54978 1.32433 7.02559 3.54247C6.71753 3.99077 6.83939 4.59843 7.29779 4.89965C7.75619 5.20094 8.37752 5.08175 8.68552 4.63344C9.83758 2.95691 11.7567 1.95597 13.8191 1.95597C17.2268 1.95597 19.9991 4.66735 19.9991 8C19.9991 11.3327 17.2267 14.044 13.8191 14.044C11.7628 14.044 9.84678 13.0476 8.69385 11.3786C8.38465 10.931 7.76306 10.8133 7.30539 11.1157C6.84779 11.4181 6.72739 12.026 7.03659 12.4736C8.56205 14.6817 11.0976 16 13.8191 16C18.3296 16 21.9991 12.4112 21.9991 8C21.9991 3.58882 18.3295 0 13.8191 0Z" fill="white"></path></svg>Log out</a>
            </div>
            <div class="sidebar-stopper"></div>
        </div>

        <!-- <div class="sidebar-bottom">
            
            <ul class="navbar-terms d-flex flex-column flex-md-column -reverse">  
                <li class="d-flex align-items-center text-center">
                    <a target="_blank" href="https://iresearchnet.com/">Contacts</a>
                </li>
                <li class="d-flex align-items-center text-center">
                    <a target="_blank" href="https://iresearchnet.com/terms-of-use/">Terms and Conditions</a>
                </li>
            </ul>
        </div> -->
    </div>
    <div class="sidebar-user d-sm-none pt-1">
        <div class="card-body">
        <div class="media">
            <div class="mr-3">
            <router-link :to="{ name: 'Profile' }">
                <img
                src="../assets/global_assets/images/image.png"
                width="38"
                height="38"
                class="rounded-circle"
                alt=""
                />
            </router-link>
            </div>

            <div class="media-body">
            <div class="media-title font-weight-semibold">
                {{ user.first_name || "" }} {{ user.last_name || "" }}
            </div>
            <div class="font-size-sm  opacity-50">
                <i class="icon-pin font-size-sm"></i>
                &nbsp;{{ user.country }}
            </div>
            </div>

            <div class="ml-3 align-self-center">
            <router-link :to="{ name: 'Profile' }" class="text-white">
                <i class="icon-cog3"></i>
            </router-link>
            </div>
        </div>
        </div>
    </div>
</div>
    <!-- /main sidebar -->
  </template>
  
  <script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import {
    actionMenuItems,
    baseMenuItems,
    orderMenuItems,
  } from "./sidebar.model";
  // import TipWriter from "./payments/modals/TipWriter.vue";
  
  export default {
    name: "Sidebar",
    components: {
      // TipWriter,
    },
    computed: {
      ...mapState("auth", ["user"]),
      ...mapState("sidebar", ["showSidebar", "sidebarMenu"]),
      ...mapState("setups", ["site_settings"]),
      ...mapState("payment", ["wallet_entries", "loading", "wallet_balance"])


    },
    data() {
      return {
        actionMenuItems: actionMenuItems,
        baseMenuItems: baseMenuItems,
        orderMenuItems: orderMenuItems,
      };
    },
    // beforeRouteUpdate() {
    //   this.getSidebarMenu()
    // },
    async mounted() {
      this.getSidebarMenu();
      this.getSiteSettings()
      await this._getWalletBalance()

    },
    
    methods: {
      ...mapActions("auth", ["doLogout"]),
      ...mapActions("sidebar", ["getSidebarMenu"]),
      ...mapMutations("sidebar", ["_toggleSidebarMobile"]),
      ...mapActions("setups", ["getSiteSettings"]),
      ...mapMutations("sidebar", ["_toggleSidebar", "_toggleSidebarMobile"]),
      ...mapActions("payment", ["_getWalletEntries", "_getWalletBalance"])


    },
  };
  </script>
  
  
  <style lang="scss" scoped>
//   .nav-item {
//     max-height: 40px !important;
//     height: 40px !important;
//   }
  .nav-link {
    padding: 8px 10px !important;
  }
  .sidebar {
    .nav-link {
      padding: 0.5rem 0.8rem;
    }
  }
  .modal-backdrop {
    z-index: 1 !important;
  }
  
  .sidebar-xs .sidebar-main .nav-sidebar > .nav-item > .nav-link {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
    max-height: 40px !important;
  }
  .nav-link.active.just-active {
    background-color: rgba(202, 201, 201, 0.74) !important;
    border-radius: 0px 20px 20px 0px;
    transition: 0.3s all ease-in-out;
  }
  
@media screen and (max-width: 767px){
.sidebar .sidebar-close-wrap .sidebar-close {
  display: block!important;
}
.logo__custom{
  color: #fff!important;
    font-weight: 900;
    text-transform: capitalize;
    font-size: 16px!important;
}

// .sidebar.bg-gradient-primary {
//   background: #00A974!important;
//   height: 100vh!important;
//   overflow:auto!important;
//   width: 372px!important;
//   min-width: 0px!important;
// }
.btn-balance {
  transition: all 0.5s;
  background: transparent;
  border: 1px solid #fff!important;
  border-radius: 4px;
  color: #FFF;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 14px 20px;
  margin: 0 0 24px 0;
  white-space: nowrap;
}

}
  .sidebar-xs .sidebar {
    a.nav-link i {
      font-size: 22px;
      padding: 6px;
    }
  
    a.nav-link.active.just-active {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }
  </style>